import getFreeShippingStatus from "@faire/web-api/api/retailer/retailerToken/free-shipping-status/post";
import { FreeShippingReason } from "@faire/web-api/indigofair/data/FreeShippingReason";
import { IFreeShippingStatusRequest } from "@faire/web-api/indigofair/data/IFreeShippingStatusRequest";
import { makeObservable } from "@faire/web/common/makeObservable";
import { singletonGetter } from "@faire/web/common/singletons/getter";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";
import { computed, observable, runInAction } from "mobx";

import {
  FlashSaleOrderSubmitted,
  OrderSubmitted,
} from "@faire/retailer/events";
import { getFreeShippingStatuses } from "@faire/retailer/serialized-data/getFreeShippingStatuses";

import { RetailerStore } from "./RetailerStore";

/**
 * Store to handle global free shipping. Doesn't handle brand-specific free
 * shipping.
 * @deprecated prefer to use `useFreeShippingStore` or `withStores` instead
 */
export class FreeShippingStore {
  /**
   * @trackfunction
   */
  static get = singletonGetter(FreeShippingStore);

  constructor() {
    makeObservable(this);
    OrderSubmitted.subscribe(() => this.fetchFreeShippingStatus());
    FlashSaleOrderSubmitted.subscribe(() => this.fetchFreeShippingStatus());
  }

  @observable
  private _freeShippingStatuses = getFreeShippingStatuses();

  private retailerStore = RetailerStore.get();

  private fetchFreeShippingStatus = async () => {
    if (this.retailerStore.retailerToken) {
      const response = await getFreeShippingStatus(
        this.retailerStore.retailerToken,
        IFreeShippingStatusRequest.build({})
      );
      runInAction(() => (this._freeShippingStatuses = response.statuses));
    }
  };

  @computed
  get hasFreeShippingOnFirstOrder(): boolean {
    if (!this.retailerStore.retailer) {
      return false;
    }

    return !!this._freeShippingStatuses?.find(
      (s) => s.reason === FreeShippingReason.FIRST_ORDER_FREE_SHIPPING
    );
  }

  @computed
  get freeShippingStatuses() {
    return this._freeShippingStatuses;
  }
}
export const useFreeShippingStore = createStoreHook(FreeShippingStore);
